// Tiny profile module. Stores the user's first name so saved worksheets can be
// auto-titled with it (e.g. "Theo - English - Year 4 - 12 May 2026").
//
// Local-only. Never sent to a server. Lives in localStorage. The user enters it in
// Settings > Profile.

const STORAGE_KEY_NAME = 'mdt_profile_name';

export function getUserName(): string {
  try {
    return localStorage.getItem(STORAGE_KEY_NAME) ?? '';
  } catch {
    return '';
  }
}

export function setUserName(name: string) {
  try {
    const trimmed = name.trim();
    if (trimmed) {
      localStorage.setItem(STORAGE_KEY_NAME, trimmed);
    } else {
      localStorage.removeItem(STORAGE_KEY_NAME);
    }
  } catch {
    // Storage unavailable - silently ignore.
  }
}
